var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import BaseComponent from '../base/BaseComponent';
var PlainComponent = function (props) {
    var _a = props.childProps, childProps = _a === void 0 ? { props: { styles: {}, style: {} }, label: '', type: '' } : _a, spots = props.spots, key = props.key;
    var _b = childProps.props || {}, _c = _b.style, style = _c === void 0 ? {} : _c, _d = _b.styles, styles = _d === void 0 ? {} : _d, htmlTagProps = __rest(_b, ["style", "styles"]);
    var injectedStyles = !isEmpty(style) ? style : !isEmpty(styles) ? styles : {};
    var children = !isEmpty(spots) ? [childProps.label, Object.values(spots)] : [childProps.label];
    return (_jsx(BaseComponent, { componentKey: "base_".concat(key), htmlTag: childProps.type, injectedStyles: injectedStyles, htmlTagProps: htmlTagProps, children: children }));
};
export default PlainComponent;
